import {
  apiPageConfigUserBaseInfo,
  ApiPageConfigUserBaseInfoResponse,
} from '@/api'

export class UserUtils {
  /** 检查用户是否登录 */
  static async checkLogined(): Promise<boolean> {
    return apiPageConfigUserBaseInfo(
      {},
      { noErrorToast: true, ignore403: true },
    ).then(
      () => true,
      () => false,
    )
  }

  /** 确保用户已登录 */
  static async ensureLogined(): Promise<ApiPageConfigUserBaseInfoResponse> {
    return apiPageConfigUserBaseInfo({}, { noErrorToast: true })
  }

  /** 获取用户信息 */
  static getInfo = UserUtils.ensureLogined
}
